<app-breadcrumb [master]="'Dobry Agent'" [parentName]="'Tagi'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group>
  <mat-tab label="Dane">
    <app-da-tag-details-view *ngIf="!modify" [blogTag]="blogTag" (modifyClicked)="modify = true"></app-da-tag-details-view>
    <app-da-tag-add *ngIf="modify" [blogTag]="blogTagObject" [mod]='true' (closeModification)="modify = false; load()" ></app-da-tag-add>
  </mat-tab>

</mat-tab-group>

